import React from "react";
import Link from "gatsby-link";
import styles from "./pricing.module.scss";
import variables from "./variables.module.scss";

const PRICING_DETAILS = [
  {
    title: "Developer",
    key: "free",
    price: "Free",

    action_color: variables.developerPrimaryColor,
    primary_color: variables.developerPrimaryColor,
    card_color: variables.whiteColor,

    features: [
      "Upto 5K monthly tracked users",
      "1,000 geo fences",
      "Single app project",
      "Push notification engine"
    ],
    linktext: "Try Now",
    link: "/signup"
  },
  {
    title: "Professional",
    key: "professional",
    price: "$300",
    price_duration: "/month",
    action_color: variables.professionalPrimaryColor,
    primary_color: variables.professionalPrimaryColor,
    card_color: variables.whiteColor,

    pricing_subtext: "Free 1 month trial",
    features: [
      "Upto 20K monthly detected users",
      "5,000 geo fences",
      "Developer features",
      "Analytics dashboard"
    ],
    linktext: "Signup",
    link: "/signup"
  },
  {
    title: "Enterprise",
    key: "enterprise",
    price: "$750",
    price_duration: "/month",

    action_color: variables.enterprisePrimaryColor,
    primary_color: variables.enterprisePrimaryColor,
    card_color: variables.whiteColor,

    pricing_subtext: "Free 1 month trial",
    features: [
      "Upto 50K monthly detected users",
      "20,000 geo fences",
      "Professional features",
      "On-call support",
      "Multiple users"
    ],
    linktext: "Signup",
    link: "/signup"
  },
  {
    title: "Premium",
    key: "premium",
    price: "Get a deal",
    price_color: variables.whiteColor,
    action_color: variables.premiumPrimaryColor,
    primary_color: variables.premiumGradientColor,
    card_color: variables.premiumGradientColor,
    features: [
      "Greater than 1 lakh monthly detected users",
      "Unlimited geo fences",
      "Enterprise features",
      "Multiple app projects",
      "Analytics webhooks",
      "Data science & insights",
      "Dedicated account manager"
    ],
    linktext: "Contact us",
    link: "/sales"
  }
];

const PricingBox = p => {
  return (
    <div className={styles.pricing__box__wrapper}>
      <div
        className={styles.pricing__title__card}
        style={{
          background: p.primaryColor
        }}
      >
        {p.title}
      </div>
      <div className={styles.pricing__box__panel}>
        <div
          style={{ background: p.cardColor }}
          className={styles.pricing__box__price__action__wrapper}
        >
          <div className={styles.pricing__box__price__wrapper}>
            <div
              style={{ color: p.priceColor }}
              className={styles.pricing__box__price}
            >
              {p.price}
              <span>{p.priceDuration}</span>
            </div>
            <div className={styles.pricing__box__price_subtext}>
              {p.pricing_subtext}
            </div>
          </div>
          <div className={styles.pricing__box__action}>
            {/* <a href={p.link}> */}
            <Link
              to={p.link}
              style={{ backgroundColor: p.buttonColor }}
              className={styles.pricing__btn}
            >
              <span>{p.linktext}</span>
            </Link>
          </div>
        </div>
        <div className={styles.pricing__box__features}>
          <ul>
            {p.features.map((f, index) => (
              <li key={index}>{f}</li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};
const PricingPage = () => {
  return (
    <div className={styles.pricing__page__panel}>
      {PRICING_DETAILS.map(entry => {
        return (
          <PricingBox
            title={entry.title}
            key={entry.key}
            price={entry.price}
            pricing_subtext={entry.pricing_subtext}
            features={entry.features}
            linktext={entry.linktext}
            link={entry.link}
            buttonColor={entry.action_color}
            cardColor={entry.card_color}
            primaryColor={entry.primary_color}
            priceDuration={entry.price_duration}
            priceColor={entry.price_color}
          />
        );
      })}
    </div>
  );
};

export default PricingPage;



// WEBPACK FOOTER //
// ./src/pages/pricing.js